import React, { memo, useCallback, useState } from "react";
import { isiOS } from "utils/user-agent";
import useMediaQuery from "hook/use-media-query";
import ControlButton from "../control-button";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import PropTypes from "prop-types";


const NavigationMenuWrapper = memo((props) => {
  const { controlBtnProps, controlBtnIcon, paperProps, children } = props;
  const isIOSDevice = isiOS();
  const isTablet = useMediaQuery('tablet');
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);

  const toggleDrawer = useCallback(
    (openState) => (event) => {
      if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

      setIsNavigationOpen((currentState) => openState ?? !currentState);
    },
    [],
  );

  return (
    <>
      <ControlButton onClick={toggleDrawer()} icon={controlBtnIcon} {...controlBtnProps} />
      <SwipeableDrawer
        disableScrollLock
        disableSwipeToOpen
        disableDiscovery={isIOSDevice}
        disableBackdropTransition={!isIOSDevice}
        anchor={isTablet ? 'bottom' : 'right'}
        open={isNavigationOpen}
        onOpen={toggleDrawer(true)}
        onClose={toggleDrawer(false)}
        PaperProps={paperProps}
      >
          {children}
      </SwipeableDrawer>
    </>
  );
});

NavigationMenuWrapper.propTypes = {
  controlBtnProps: PropTypes.shape({
    className: PropTypes.string,
    iconClassName: PropTypes.string,
  }),
  paperProps: PropTypes.shape({
    className: PropTypes.string,
  }),
  controlBtnIcon: PropTypes.elementType,
};

export default NavigationMenuWrapper;
